export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/pages/profile/Profile'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/profile/identity',
    name: 'identity',
    component: () => import('@/pages/profile/identity/Identity'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/profile/timezone',
    name: 'timezone',
    component: () => import('@/pages/profile/timezone/Timezone'),
    meta: {
      requiresAuth: true,
    },
  },
];
